import React from "react";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FETCH_GROUPORDER_DOWNLOAD } from "../../store/Report/Report.constant";

const ReportCard = ({ data, currentPage, setCurrentPage }) => {
  const dispatch = useDispatch();
  const { user_group_orders, pagination } = data || {};
  const { current_page, per_page, total_count, total_pages } = pagination || {};
  const totalPages = total_pages;
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  const finalTotalSpend =
    user_group_orders.reduce((sum, item) => sum + item.total, 0) / 100;
  const handleDownload = (payload) => {
    dispatch({ type: FETCH_GROUPORDER_DOWNLOAD, payload });
  };
  return (
    <div>
      {/* Table */}
      <table className="report-table">
        <thead>
          <tr>
            <th>Delivery Date</th>
            <th>Vendor</th>
            <th>Total Top Up</th>
            <th>Total People Joined</th>
            <th>Price Per Person AVG</th>
            <th>Alotted Budget</th>
            <th>Total Spend</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {user_group_orders.map((item) => (
            <tr key={item.id}>
              <td>
                {item.delivery_date_time &&
                  format(
                    new Date(item.delivery_date_time * 1000),
                    "EEEE, MMMM do, yyyy, h:mm aaa"
                  )}
              </td>
              <td>{item.chef_name}</td>
              <td>
                {"$" +
                  (item.total_paid_by_employees / 100).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 3,
                    }
                  ) || "$0.00"}
              </td>
              <td>
                {item.joined_member_count.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 3,
                }) || "0"}
              </td>
              <td>
                $
                {item?.joined_member_count > 0
                  ? (item?.total / item?.joined_member_count / 100)?.toFixed(2)
                  : 0}
              </td>
              <td>
                {"$" +
                  (item.per_person_budget.cents / 100).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 3,
                    }
                  ) || "$0.00"}
              </td>
              <td>
                {"$" +
                  (item.total / 100).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 3,
                  }) || "$0.00"}
              </td>
              <td>
                <span className="button-wrapper-report">
                  {" "}
                  <Link
                    to={`/group_order/${item.uuid}`}
                    target="_blank"
                    className="column-action-button link-no-style"
                  >
                    View
                  </Link>
                  <button
                    onClick={() => {
                      handleDownload({
                        id: item?.id,
                        creator_id: item?.creator_id,
                      });
                    }}
                    className="column-action-pdf-button link-no-style"
                  >
                    Download
                  </button>
                </span>
              </td>
            </tr>
          ))}{" "}
          <tr style={{ fontWeight: "bold" }}>
            <td colSpan="6">Final Total Spend</td>
            <td>
              {"$" +
                finalTotalSpend.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 3,
                }) || "$0.00"}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div className="pagination">
        <button onClick={prevPage} disabled={currentPage === 1}>
          Previous
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button onClick={nextPage} disabled={currentPage === totalPages}>
          Next
        </button>
      </div>
    </div>
  );
};

export default ReportCard;
